"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _axios = _interopRequireDefault(require("axios"));

var _components = require("@abroad/components");

var _constant = require("./constant");

var RestClient = /*#__PURE__*/function () {
  function RestClient(_ref) {
    var baseUrl = _ref.baseUrl;
    (0, _classCallCheck2["default"])(this, RestClient);
    this.baseUrl = baseUrl;
  }

  (0, _createClass2["default"])(RestClient, [{
    key: "getConfig",
    value: function getConfig(_ref2) {
      var config = _ref2.config;
      var axiosConfig = {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      };
      return Object.assign({}, axiosConfig, config);
    }
  }, {
    key: "errorHandle",
    value: function errorHandle(error) {
      if (error.response) {
        var _error$response;

        if ((_error$response = error.response) !== null && _error$response !== void 0 && _error$response.data) {
          var _error$response$data, _error$response2, _error$response3, _error$response4, _error$response4$data;

          if (((_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.code) === 'two_factor_not_verified') {
            setTimeout(function () {
              window.location.replace("".concat(process.env.REACT_APP_CLIENT_DOMAIN, "/2fa-setup"));
            }, 500);
            throw error.response.data;
          } else if (((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 401) {
            if (!_constant.ADMIN_URLS.includes(window.location.origin)) {
              window.location.replace("".concat(window.location.origin, "/force-logout"));
              throw error.response.data;
            } else {
              window.location.replace(process.env.REACT_APP_CLIENT_DOMAIN);
              throw error.response.data;
            }
          } else if (((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 500) {
            setTimeout(function () {
              _components.history.replace('/under-maintenance');
            }, 500);
            throw error.response.data;
          } else if ((_error$response4 = error.response) !== null && _error$response4 !== void 0 && (_error$response4$data = _error$response4.data) !== null && _error$response4$data !== void 0 && _error$response4$data.paymentRequired) {
            setTimeout(function () {
              var _error$response5, _error$response5$data;

              var questId = (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : _error$response5$data.questId;

              if (questId) {
                // Experience enrollment done but deposit/full payment pending
                _components.history.replace("/your-experiences/".concat(questId, "/payments"));
              } else {
                var _error$response6, _error$response6$data;

                _components.history.replace("/user-payment?plan=".concat((_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.planCode));
              }
            }, 500);
            throw error.response.data;
          }

          return new Promise(function (resolve, reject) {
            var _error$response7;

            reject((_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.data);
          });
        } else {
          return error.response;
        }
      } else {
        throw error;
      }
    }
  }, {
    key: "get",
    value: function get(resourceUrl) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return _axios["default"].get("".concat(this.baseUrl).concat(resourceUrl), this.getConfig(args))["catch"](this.errorHandle);
    }
  }, {
    key: "post",
    value: function post(resourceUrl, data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return _axios["default"].post("".concat(this.baseUrl).concat(resourceUrl), JSON.stringify(data), this.getConfig(args))["catch"](this.errorHandle);
    }
  }, {
    key: "put",
    value: function put(resourceUrl, data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return _axios["default"].put("".concat(this.baseUrl).concat(resourceUrl), JSON.stringify(data), this.getConfig(args))["catch"](this.errorHandle);
    }
  }, {
    key: "patch",
    value: function patch(resourceUrl, data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return _axios["default"].patch("".concat(this.baseUrl).concat(resourceUrl), JSON.stringify(data), this.getConfig(args))["catch"](this.errorHandle);
    }
  }, {
    key: "delete",
    value: function _delete(resourceUrl, data) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return _axios["default"]["delete"]("".concat(this.baseUrl).concat(resourceUrl), (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, this.getConfig(args)), {}, {
        data: data
      }))["catch"](this.errorHandle);
    }
  }]);
  return RestClient;
}();

exports["default"] = RestClient;